import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NEXT_NAMESPACE, I18NextModule } from 'angular-i18next';
import ChartsModule from 'app/CustomChatModule';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';


import { HbComponentLibraryModule } from '../../component-library/component-library.module';
import { HbSharedModule } from '../../shared/hb-shared.module';
import { HbSharedUiModule } from '../../shared/ui/hb-shared-ui.module';
import { DashboardRoutingModule, routedComponents } from './dashboard-routing.module';
import { DashboardService } from './dashboard.service';
import { AddWidgetDialogComponent } from './widgets/add-widget/add-widget-dialog.component';
import { BarComponent } from './widgets/bar/bar.component';
import { BaseWidgetComponent } from './widgets/base-widget/base-widget.component';
import { WidgetSubtitleTooltipPipe } from './widgets/base-widget/widget-subtitle-tooltip.pipe';
import { WidgetSubtitlePipe } from './widgets/base-widget/widget-subtitle.pipe';
import { DisplayWidgetUsingPermissionsPipe } from './widgets/display-widget-using-permissions.pipe';
import { GaugeComponent } from './widgets/gauge/gauge.component';
import { LineComponent } from './widgets/line/line.component';
import { ViewDataWidgetComponent } from './widgets/view-data-widget/view-data-widget.component';
import { WidgetConfigurationDialogComponent } from './widgets/widget-configuration/widget-configuration-dialog.component';
import { WidgetConfigurationService } from './widgets/widget-configuration/widget-configuration-dialog.service';
import { WidgetParametersService } from './widgets/widget-parameters/widget-parameters.service';

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    ChartsModule,
    BsDropdownModule,
    FormsModule,
    CheckboxModule,
    TreeModule,
    TableModule,
    HbSharedModule,
    HbSharedUiModule,
    TooltipModule,
    DropdownModule,
    HbComponentLibraryModule,
    I18NextModule.forRoot(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    routedComponents,
    GaugeComponent,
    LineComponent,
    BarComponent,
    BaseWidgetComponent,
    WidgetConfigurationDialogComponent,
    AddWidgetDialogComponent,
    ViewDataWidgetComponent,
    WidgetSubtitlePipe,
    WidgetSubtitleTooltipPipe,
    DisplayWidgetUsingPermissionsPipe,
  ],
  exports: [GaugeComponent, BaseWidgetComponent, BarComponent, LineComponent],
  bootstrap: [WidgetConfigurationDialogComponent, AddWidgetDialogComponent],
  providers: [DashboardService, WidgetConfigurationService, WidgetParametersService,
    {
      provide: I18NEXT_NAMESPACE,
      useValue: ['module.dashboard'],
    },
  ],
})
export class DashboardModule { }
